import React from 'react'
import { useParams } from 'react-router-dom'
import { Pagination } from 'lib/shared'
import { FadeIn, Spinner, EmptyContainer } from 'lib/ui'
import { NoMatch } from 'lib/shared/scenes/NoMatch'
import { useBlogContext } from 'hooks/blog'
import { MainTitle } from '../../components/MainTitle'
import { NoPosts } from '../../components/NoPosts'
import { PostsGrid } from '../../components/PostsGrid'
import { PaginationStyles } from 'components/PaginationStyles'
import { PaginationWrapper } from './components/Styled'
import { CategoryList } from '../../components/CategoryList'
import { BlogLayout } from '../../components/BlogLayout'
import { Toolbar } from '../../components/Toolbar'
import { MetaData } from 'components/MetaData'

export const Category = () => {
  const { slug } = useParams<{ slug: string }>()
  const {
    loading,
    posts,
    name,
    postSlugs,
    handlePageChange,
    pageInfo,
    isViewAll,
    categoryExists,
    metaData
  } = useBlogContext()

  if (!categoryExists) {
    return (
      <NoMatch />
    )
  }

  return (
    <>
      {metaData && (
        <MetaData
          title={metaData.metaTitle}
          description={metaData.metaDescription}
          keywords={metaData.metaKeywords}
        />
      )}
      <FadeIn
        key={`title-${slug}`}
      >
        <MainTitle
          title={name}
        />
      </FadeIn>

      {!postSlugs || loading ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <BlogLayout>
          <FadeIn
            key={`content-${slug}`}
          >
            {posts?.length ? (
              <PostsGrid
                title={isViewAll ? 'All Articles' : undefined}
                posts={posts}
              />
            ) : (
              <NoPosts />
            )}

            <PaginationWrapper>
              <PaginationStyles>
                {pageInfo && (
                  <Pagination
                    currentPage={pageInfo?.currentPage}
                    pageSize={pageInfo?.pageSize}
                    totalItems={pageInfo?.totalItems}
                    onChange={handlePageChange}
                  />
                )}
              </PaginationStyles>
            </PaginationWrapper>
          </FadeIn>
          <div>
            <Toolbar />
            <CategoryList />
          </div>
        </BlogLayout>
      )}
    </>
  )
}
